import React from 'react';
import { Container, Eyebrow, StarMark, PillButton } from './ui';

// Swap `price` / `unit` for real numbers whenever you want to publish rates.
const plans = [
  {
    name: 'Project Build',
    price: 'Fixed',
    unit: '/Project',
    desc: 'Perfect for startups and businesses that need a website, web app, or MVP built from scratch with a clear scope.',
    features: [
      'Website Or Web Application Build',
      'Responsive UI For Every Device',
      'Backend APIs & Database Setup',
      'Deployment & Domain Setup',
      'Post-Launch Bug Fixes',
    ],
    dark: true,
  },
  {
    name: 'Dedicated Partner',
    price: 'Monthly',
    unit: '/Retainer',
    desc: 'For growing teams that need ongoing engineering — new features, mobile apps, integrations, and continuous improvement.',
    features: [
      'Full-Stack Web & Mobile Development',
      'ERP, CRM & Custom Integrations',
      'AI & Automation Features',
      'Performance & Security Monitoring',
      'Priority Support & Weekly Sync',
    ],
  },
];

const PlanCard = ({ plan }) => {
  const { dark } = plan;
  return (
    <div
      className={`rounded-3xl p-2.5 sm:p-3 flex flex-col ${
        dark ? 'bg-white/[0.06] border border-white/10 backdrop-blur' : 'bg-[#f4f6fa]'
      }`}
    >
      <div className={`rounded-2xl p-5 ${dark ? 'bg-white/[0.07] border border-white/10' : 'bg-[#e6e9f0]'}`}>
        <div className="flex items-center justify-between">
          <span className={`text-sm ${dark ? 'text-white/85' : 'text-[#111]/75'}`}>{plan.name}</span>
          <StarMark className={`w-4 h-4 ${dark ? 'text-white/70' : 'text-[#3b5bfd]'}`} />
        </div>
        <p className={`mt-2 text-[28px] font-medium tracking-[-0.03em] ${dark ? 'text-white' : 'text-[#111]'}`}>
          {plan.price}
          <span className={`text-sm font-normal tracking-normal ${dark ? 'text-white/70' : 'text-[#111]/60'}`}>{plan.unit}</span>
        </p>
        <p className={`mt-3 text-sm leading-relaxed max-w-[420px] ${dark ? 'text-white/75' : 'text-[#111]/65'}`}>{plan.desc}</p>
      </div>

      <div className="px-2.5 pt-5 pb-2 flex-1">
        <p className={`text-sm font-medium ${dark ? 'text-white' : 'text-[#111]'}`}>What's Included:</p>
        <ul className="mt-3 space-y-2">
          {plan.features.map((f) => (
            <li key={f} className={`flex items-center gap-2.5 text-sm ${dark ? 'text-white/75' : 'text-[#111]/70'}`}>
              <span className="w-1 h-1 rounded-full bg-[#5f78ff]" />
              {f}
            </li>
          ))}
        </ul>
      </div>

      <PillButton to="/contact" variant={dark ? 'glass' : 'dark'} block className="mt-5">
        Get In Touch
      </PillButton>
    </div>
  );
};

const Pricing = () => (
  <section id="pricing" className="bg-[#0b2471] pb-24">
    <Container>
      <div className="text-center">
        <Eyebrow dark>Engagement Models</Eyebrow>
        <h2 className="mt-3 text-[32px] sm:text-[42px] lg:text-[46px] font-medium leading-[1.08] tracking-[-0.04em] text-white">
          Flexible development support
          <br />
          for growing businesses
        </h2>
      </div>

      <div className="mt-12 grid grid-cols-1 lg:grid-cols-[5fr_7fr] gap-4">
        {plans.map((p) => (
          <PlanCard key={p.name} plan={p} />
        ))}
      </div>
    </Container>
  </section>
);

export default Pricing;
